import { css } from "styled-components";
import token from "styled-token";
import { InputMixin } from "./InputMixin";
/** @class AdornmentLeftMixin */

/** @method */

export var AdornmentLeftMixin = function AdornmentLeftMixin() {
  return "\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    border-right: 0;\n";
};
/** @class AdornmentRightMixin */

/** @method */

export var AdornmentRightMixin = function AdornmentRightMixin() {
  return "\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-left: 0;\n";
};
var zsgCSS = token("Input.adornmentColor", function (color) {
  return color && "\n        &[disabled] {\n            color: " + color + ";\n        }\n    ";
});
/** @class AdornmentMixin */

/** @method */

export var AdornmentMixin = function AdornmentMixin(props) {
  return token("Input.adornmentColor", function (color) {
    return css(["", " color:", ";width:auto;display:inline-flex;align-items:center;user-select:none;", ""], InputMixin(props), color, zsgCSS(props));
  })(props);
};